/* outpost-heat.js — SaharaCase self-hosted heatmap beacon (HEATMAPS_PROPOSTA v2).
 *
 * WHAT IT COLLECTS (and all it collects):
 *   one event per page view, sent when the visitor leaves the page:
 *   path (allowlisted shapes only, no query strings), viewport size class,
 *   deepest section seen, scroll depth bucket, time-on-page bucket, and up to
 *   100 clicks as (section, x-cell 0-100, y-quartile). No identifiers, no
 *   cookies, no IPs, no referrers, no exact coordinates, no text.
 *
 * WHEN IT STAYS SILENT (checked before anything else runs):
 *   - Global Privacy Control is on
 *   - Shopify customer privacy says analytics is not allowed
 *   - the page's path is not one of the allowlisted shapes
 */
(function () {
  "use strict";

  var ENDPOINT = "https://outpost.taild76120.ts.net/api/eco";
  if (!ENDPOINT) return;

  if (navigator.globalPrivacyControl) return;

  function analyticsAllowed() {
    try {
      var cp = window.Shopify && window.Shopify.customerPrivacy;
      if (!cp) return false;
      if (typeof cp.analyticsProcessingAllowed === "function") return !!cp.analyticsProcessingAllowed();
      if (typeof cp.userCanBeTracked === "function") return !!cp.userCanBeTracked();
      return false;
    } catch (e) { return false; }
  }

  var RX_PATH = /^(\/[a-z]{2}-[a-z]{2})?(\/|\/products\/[a-z0-9-]{1,80}|\/collections\/[a-z0-9-]{1,80}|\/pages\/[a-z0-9-]{1,80}|\/blogs\/[a-z0-9-]{1,60}\/[a-z0-9-]{1,80}|\/cart|\/search)$/;
  var path = (location.pathname || "/").toLowerCase().replace(/\/+$/, "") || "/";
  if (path.length > 120 || !RX_PATH.test(path)) return;

  var viewport = window.innerWidth < 640 ? "sm" : window.innerWidth < 1024 ? "md" : "lg";
  var RX_SEC = /^shopify-section-[A-Za-z0-9_-]{1,64}$/;

  function sectionOf(el) {
    while (el && el !== document.body) {
      if (el.id && RX_SEC.test(el.id)) return el.id;
      el = el.parentElement;
    }
    return "";
  }

  var t0 = Date.now();
  var maxScroll = 0;
  var deepestSec = "";
  var deepestTop = -1;
  var clicks = [];

  function onScroll() {
    var doc = document.documentElement;
    var max = Math.max(1, doc.scrollHeight - window.innerHeight);
    var p = Math.min(1, (window.scrollY || doc.scrollTop || 0) / max);
    if (p > maxScroll) maxScroll = p;
  }
  window.addEventListener("scroll", onScroll, { passive: true });
  onScroll();

  if (window.IntersectionObserver) {
    var io = new IntersectionObserver(function (entries) {
      for (var i = 0; i < entries.length; i++) {
        var e = entries[i];
        if (!e.isIntersecting) continue;
        var top = e.boundingClientRect.top + (window.scrollY || 0);
        if (top > deepestTop) { deepestTop = top; deepestSec = e.target.id; }
      }
    }, { threshold: 0.25 });
    var secs = document.querySelectorAll('[id^="shopify-section-"]');
    for (var i = 0; i < secs.length; i++) io.observe(secs[i]);
  }

  document.addEventListener("click", function (ev) {
    if (clicks.length >= 100) return;
    var sec = sectionOf(ev.target);
    var host = sec ? document.getElementById(sec) : null;
    var y = "";
    if (host) {
      var r = host.getBoundingClientRect();
      if (r.height > 0) {
        var q = (ev.clientY - r.top) / r.height;
        y = q < 0.25 ? "0_25" : q < 0.5 ? "25_50" : q < 0.75 ? "50_75" : "75_100";
      }
    }
    clicks.push({ sec: sec, x: Math.max(0, Math.min(100, Math.round((ev.clientX / window.innerWidth) * 100))), y: y });
  }, { passive: true, capture: true });

  function bucket25(p) { return p < 0.25 ? "0_25" : p < 0.5 ? "25_50" : p < 0.75 ? "50_75" : "75_100"; }
  function bucketDwell(s) { return s < 10 ? "0_10" : s < 30 ? "10_30" : s < 120 ? "30_120" : s < 600 ? "120_600" : "600_up"; }

  var sent = false;
  function send() {
    if (sent) return;
    if (!analyticsAllowed()) return;
    sent = true;
    var body = JSON.stringify({
      path: path,
      viewport: viewport,
      scroll: maxScroll > 0 ? bucket25(maxScroll) : "",
      sec: deepestSec,
      dwell: bucketDwell((Date.now() - t0) / 1000),
      clicks: clicks
    });
    try {
      if (navigator.sendBeacon && navigator.sendBeacon(ENDPOINT, new Blob([body], { type: "text/plain" }))) return;
    } catch (e) {}
    try {
      fetch(ENDPOINT, { method: "POST", body: body, headers: { "content-type": "text/plain" }, keepalive: true, credentials: "omit" });
    } catch (e) {}
  }

  window.addEventListener("pagehide", send);
  document.addEventListener("visibilitychange", function () {
    if (document.visibilityState === "hidden") send();
  });
})();